import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios,axios)


export default new Vuex.Store({
    state: {
        items: [],
        category: [],
        storage:[],

    },
    getters:{
        storage: state => {
            return state.storage;
        },

        items: state => {
            return state.items;
        },

        category : state => {
            return state.category
        }
    },
    mutations: {
        SET_Storage (state, storage) {
            state.storage = storage
        },
        SET_Item (state, items) {
            state.items = items
        },
        SET_Category (state, category) {
            state.category = category
        }
    },
    actions: {

        loadItems ({ commit }) {
            axios
                .post('https://entityserver.manikworks.com/bookmgr',null,{
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Content-Type': 'application/json',
                        'EntityActionType': 'FETCH.ONE.OUTLET',
                        'OutletHandle': sessionStorage.getItem('handle'),
                        'BookDS': 'BOOKING2',
                        'Channel': 'WEB',
                        'Latitude': '32',
                        'Longitude': '12',
                        'CountryID': '100000',
                        'CitizenHandle': 'aaa-asasa'
                    }
                })
                .then(response => response.data)
                .then(items =>{
                    console.log(items)
                    sessionStorage.setItem('Latitude',items.ManikJSon[0].JSon0[0].Latitude)
                    sessionStorage.setItem('Longitude',items.ManikJSon[0].JSon0[0].Longitude)
                    sessionStorage.setItem('currency',items.ManikJSon[0].JSon0[0].CurrencyText)
                    sessionStorage.setItem('StoreName',items.ManikJSon[0].JSon0[0].CompanyName)
                    sessionStorage.setItem('StoreAddress',items.ManikJSon[0].JSon0[0].LocalityName)
                    sessionStorage.setItem('storeHandle',items.ManikJSon[0].JSon0[0].StoreHandle)
                    sessionStorage.setItem('favicon',items.ManikJSon[0].JSon0[0].FaviconURL)
                    sessionStorage.setItem('countryId',items.ManikJSon[0].JSon0[0].CountryID)
                    sessionStorage.setItem('LgContext',items.ManikJSon[0].JSon0[0].ECommLGContext)
                    sessionStorage.setItem('ECommPlan',items.ManikJSon[0].JSon0[0].ECommPlan)
                    sessionStorage.setItem('ECommDS',items.ManikJSon[0].JSon0[0].ECommDS)
                    sessionStorage.setItem('PortalDS',items.ManikJSon[0].JSon0[0].PortalDS)
                    sessionStorage.setItem('BusinessHandle',items.ManikJSon[0].JSon0[0].BusinessHandle)
                    sessionStorage.setItem('radius',items.ManikJSon[0].JSon0[0].IARadius)
                    sessionStorage.setItem('StoreBranchHandle',items.ManikJSon[0].JSon0[0].StoreBranchHandle)
                    sessionStorage.setItem('companyHandle',items.ManikJSon[0].JSon0[0].CompanyHandle)

                    document.title = items.ManikJSon[0].JSon0[0].CompanyName
                    commit('SET_Item',items)
                })
        },

        loadCategory ({ commit }) {
            axios
                .post('https://entityserver.manikworks.com/bookmgr',null,{
                    headers: {
                        'Authorization': 'Bearer ' + sessionStorage.getItem('Token'),
                        'Content-Type': 'application/json',
                        'EntityActionType': 'FETCH.OUTLET.CATALOG',
                        'OutletHandle': sessionStorage.getItem('handle'),
                        'BookDS': 'BOOKING2',
                        'Channel': 'WEB',
                        'Latitude': '32',
                        'Longitude': '12',
                        'CountryID': '100000',
                        'CitizenHandle': 'aaa-asasa'
                    }
                })
                .then(response => response.data)
                .then(category =>{
                    commit('SET_Category',category)
                })
        },
    }
})